import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

const StyledTypography = styled(Typography)(() => ({
  fontWeight: 500,
}));

export default StyledTypography;
